import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-comment-preview-modal',
  templateUrl: './comment-preview-modal.component.html',
  styleUrls: ['./comment-preview-modal.component.scss'],
})
export class CommentPreviewModalComponent {
  @Input() attachment: any = null;
  @Input() comment: any = null;

  constructor(private modalCtrl: ModalController) {}

  close(): void {
    this.modalCtrl.dismiss();
  }

  getAttachmentUrl(): string {
    return this.attachment?.url || this.attachment?.base64 || '';
  }

  getAttachmentLocation(): string {
    return `${this.attachment?.location || this.attachment?.locationText || ''}`.trim();
  }

  isImageAttachment(): boolean {
    const filetype = `${this.attachment?.filetype || ''}`.toLowerCase();
    if (filetype.startsWith('image/')) return true;
    const name = `${this.attachment?.name || ''}`.toLowerCase();
    return /\.(png|jpe?g|gif|webp|bmp|svg)$/.test(name);
  }

  isVideoAttachment(): boolean {
    const filetype = `${this.attachment?.filetype || ''}`.toLowerCase();
    if (filetype.startsWith('video/')) return true;
    const name = `${this.attachment?.name || ''}`.toLowerCase();
    return /\.(mp4|mov|avi|mkv|webm)$/.test(name);
  }
}
